export default {
  nome: {
    value: '',
    required: true,
    state: null
  },
  url: {
    value: '',
    required: true,
    state: null
  },
  usuario: {
    value: '',
    required: true,
    state: null
  },
  senha: {
    value: '',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/parametros/encurtador/components/add/campanhaencurtadoradd-form.js